/** Find related content to the specified entity */

import type { Entity, Persisted, SearchFilter } from '@tunasong/schemas'
import { useMemo } from 'react'
import { allQueries } from './queries/index.js'
import { useAdvancedSearch } from './search.hook.js'

export const useRelatedContent = ({ entity, filter }: { entity?: Persisted<Entity>; filter?: SearchFilter }) => {
  /** This must be stable */
  const query = useMemo(
    () =>
      entity?.name
        ? allQueries.relatedContent({
            query: entity.name,
            filter,
          })
        : undefined,
    [entity, filter]
  )
  return useAdvancedSearch(query)
}
